import { render, staticRenderFns } from "./FormProfileWba.vue?vue&type=template&id=5f62544e&scoped=true&"
import script from "./FormProfileWba.vue?vue&type=script&lang=js&"
export * from "./FormProfileWba.vue?vue&type=script&lang=js&"
import style0 from "./FormProfileWba.vue?vue&type=style&index=0&id=5f62544e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62544e",
  null
  
)

export default component.exports